import { useLanguage } from '@i18n/useLanguage'
import Column from '@app/components/layout/Column'
import { i18n } from '@i18n/index'
import { MobileMenuPage } from '../blocks/common'
import { MegaMenuMobileItem } from '../blocks/MegaMenuMobileItem'
import {
  faMagnifyingGlass,
  faRocketLaunch,
  faBookOpenReader,
  faUsers,
} from '@fortawesome/pro-solid-svg-icons'

export type MainMenuProps = {
  setPage: (page: MobileMenuPage) => void
}

export const MainMenu = ({ setPage }: MainMenuProps) => {
  const [language] = useLanguage()
  const translations = i18n.languages[language].app.nav

  return (
    <Column gap="1rem" style={{ alignSelf: 'stretch', flexGrow: 1 }}>
      <MegaMenuMobileItem
        icon={faMagnifyingGlass}
        label={translations.find}
        description={translations.findDescription}
        backgroundColor="#C8F5E3"
        onClick={() => setPage(MobileMenuPage.find)}
      />
      <MegaMenuMobileItem
        icon={faRocketLaunch}
        label={translations.start}
        description={translations.megaMenu.startMenu.citizens.description}
        backgroundColor="var(--brand-tertiary)"
        onClick={() => setPage(MobileMenuPage.start)}
      />
      <MegaMenuMobileItem
        icon={faBookOpenReader}
        label={translations.learn}
        description={translations.megaMenu.learnMenu.knowledgeHub.description}
        backgroundColor="var(--palette-yellow-300)"
        onClick={() => setPage(MobileMenuPage.learn)}
      />
      <MegaMenuMobileItem
        icon={faUsers}
        label={translations.aboutUs}
        description={translations.megaMenu.aboutUsMenu.about.description}
        backgroundColor="var(--palette-blue-100)"
        onClick={() => setPage(MobileMenuPage.aboutUs)}
      />
    </Column>
  )
}
